export const errorMessage = e => {
  if (e.response?.data?.error) return e.response.data.error
  if (e.code === 'ERR_NETWORK' || e.message === 'Network Error') return 'Connection interrupted. Check the latest status before retrying.'
  return e.message
}
export const errorCode = e => e.response?.data?.code
